import React from 'react';
import axios from "axios";
import { useState, useEffect, useMemo, useRef } from 'react';
import MaterialReactTable from 'material-react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faPencil, faTrashAlt, faEdit } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";

import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { ExportToCsv } from "export-to-csv"; //or use your library of choice here
import { Box, Button } from "@mui/material";
// import { MultiSelect } from "react-multi-select-component";
import Select, { components } from "react-select";

const RADList = () => {
    const navigate = useNavigate();
    const [optionState, setOptionState] = useState([]);
    const [stateValue, setStateValue] = useState([]);
    const [optionDistrict, setOptionDistrict] = useState([]);
    const [districtValue, setDistrictValue] = useState([]);
    const [farmerData, setfarmerData] = useState([]);
    const [isFetching, setIsFetching] = useState(true);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const fetchedVillageKeys = useRef(new Set());
    const [hasNextPage, setHasNextPage] = useState(true);
    const [LoaderFarmer, setLoaderFarmer] = useState(false);
    const [isFetchingState, setIsFetchingState] = useState(true);
    const [selectedDataSetDistrict, setselectedDataSetDistrict] = useState('');
    const [optionSubDistrict, setOptionSubDistrict] = useState([]);
    const [subdistrictValue, setsubDistrictValue] = useState([]);
    const [optionVillage, setOptionVillage] = useState([]);
    const [villageValue, setvillageValue] = useState([]);
    const [selectedDataSetSubDistrict, setselectedDataSetSubDistrict] = useState('');
    const [selectedDataSetVillage, setselectedDataSetVillage] = useState('');
    const [surveyValue, setSurveyValue] = useState("");
    const [surveyorNameValue, setSurveyorNameValue] = useState("");
    const [mobilenoValue, setMobilenoValue] = useState("");
    const [landareaValue, setlandareaValue] = useState("");
    const [totalareaValue, settotalareaValue] = useState("");
    const [surveynoValue, setSurveynoValue] = useState("");
    const [editCode, setEditCode] = useState({});
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [cropSeason, setCropSeason] = useState([]);
    const [cropSeasonValue, setCropSeasonValue] = useState(''); 
    const [cropGroup, setCropGroup] = useState([]);
    const [cropGroupValue, setCropGroupValue] = useState('');
    const [cropName, setCropName] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const [cropNameValue, setCropNameValue] = useState('');
    const [isStateDisabled, setIsStateDisabled] = useState(false);
        const [isDistrictDisabled, setIsDistrictDisabled] = useState(false);
        const [isSubDistrictDisabled, setIsSubDistrictDisabled] = useState(false);

        const getStoredDistrictRef = () => {
        const districtCode = sessionStorage.getItem("districtCodeModel");
        const districtName = sessionStorage.getItem("districtNameModel");
        if (districtCode && districtCode !== "null" && districtCode !== "0") {
            return districtCode;
            
        }
        if (districtName && districtName !== "null" && districtName !== "0") {
            return districtName;
        }
        return "";
    };

    const findMatchingOption = (options, ref) => {
        if (!ref || ref === "null" || ref === "0") return null;
        const refStr = String(ref).trim();
        return options.find((option) =>
            String(option.value) === refStr ||
            option.value == ref ||
            String(option.label).trim().toLowerCase() === refStr.toLowerCase()
        ) || null;
    };

    const findDistrictSelectValue = (options, selectedDistrict) => {
        if (!selectedDistrict || selectedDistrict === "null" || selectedDistrict === "0") return null;
        return findMatchingOption(options, selectedDistrict);
    };
    const isOptionSelected = (selectedValues, option) => {
        if (!Array.isArray(selectedValues) || selectedValues.length === 0) return false;
        return selectedValues.some((selected) =>
            String(selected) === String(option.value) ||
            String(selected).trim().toLowerCase() === String(option.label).trim().toLowerCase()
        );
    };
   
    useEffect(() => {
        getStates();
    
    }, []);

    //Rupali
     const fetchSubDistricts = async(stateCode, districtCode) => {
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                stateCode: stateCode.toString(),
                districtCode: districtCode.toString()
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
                body: raw
            };

            const response = await fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/subdistrict`,
                requestOptions
            );

            const result = await response.text();
            const localFormDataSubDistrict = JSON.parse(result).dataContent;

            let myArraySubDistrict = [];
            localFormDataSubDistrict.map((item, key) => {
                myArraySubDistrict.push({ 
                    label: item.subDistrictName, 
                    value: item.subDistrictCode, 
                    districtCode: item.districtCode 
                });
            });

            setOptionSubDistrict(myArraySubDistrict);
            setIsFetching(false);
        } catch (error) {
            console.error("Error fetching sub-districts:", error);
        }
    };

    // Function to fetch villages for auto-selected sub-district
    const fetchVillages = async (stateCode, districtCode, subDistrictCode) => {
        // Check if we already tried to fetch villages for this combination
        const villageKey = `${stateCode}-${districtCode}-${subDistrictCode}`;
        if (fetchedVillageKeys.current.has(villageKey)) {
            return; // Don't fetch again
        }
        
        // Mark this combination as attempted
        fetchedVillageKeys.current.add(villageKey);
        
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                stateCode: stateCode.toString(),
                districtCode: districtCode.toString(),
                subDistrictCode: subDistrictCode.toString()
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
                body: raw
            };

            const response = await fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/village`,
                requestOptions
            );

            const result = await response.text();
            const parsedResult = JSON.parse(result);
            const localFormDataVillage = parsedResult.dataContent;

            let myArrayVillage = [];
            if (localFormDataVillage && localFormDataVillage.length > 0) {
                localFormDataVillage.map((item, key) => {
                    myArrayVillage.push({ 
                        label: item.villageName, 
                        value: item.villageCode, 
                        subDistrictCode: item.subDistrictCode 
                    });
                });
            }

            setOptionVillage(myArrayVillage);
            setIsFetching(false);
        } catch (error) {
            console.error("Error fetching villages:", error);
            setOptionVillage([]);
            setIsFetching(false);
        }
    };

         // New useEffect to handle user-level restrictions after states are loaded
            useEffect(() => {
                if (optionState.length > 0) {
                    const userType = sessionStorage.getItem("userTypeCodeModel");
                    // Try both possible session storage keys for state and district codes
                     const stateCode = sessionStorage.getItem("stateNameModel");
                     const districtCode = getStoredDistrictRef();
                     const subDistrictCode = sessionStorage.getItem("subDistrictNameModel"); 
                  
                    // First, select the values based on user permissions
                    if (userType === "2" && stateCode && stateCode !== "null" && stateCode !== "0") {
                        // State level user - auto-select state
                        // Try to find the matching option and use its exact value format
                        const matchingOption = optionState.find(option => option.value == stateCode || option.value === Number(stateCode) || option.value === String(stateCode));
                        if (matchingOption) {
                            setStateValue([matchingOption.value]);
                        } else {
                            setStateValue([stateCode]);
                        }
                        setIsFetchingState(false); // Trigger district loading
                    } else if (userType === "3" && stateCode && stateCode !== "null" && stateCode !== "0") {
                        // District level user - auto-select state
                        const matchingOption = optionState.find(option => option.value == stateCode || option.value === Number(stateCode) || option.value === String(stateCode));
                        if (matchingOption) {
                            setStateValue([matchingOption.value]);
                        } else {
                            setStateValue([stateCode]);
                        }
                        setIsFetchingState(false); // Trigger district loading
                    } else if (userType === "4" && stateCode && stateCode !== "null" && stateCode !== "0") {
                        // Sub-district level user - auto-select state
        
                        const matchingOption = optionState.find(option => option.value == stateCode || option.value === Number(stateCode) || option.value === String(stateCode));
                        if (matchingOption) {
                            setStateValue([matchingOption.value]);
                        } else {
                            setStateValue([stateCode]);
                        }
                        setIsFetchingState(false); // Trigger district loading
                    } else {
                        // Regular user or admin - no auto-selection
                        setStateValue([]);
                    }
                }
            }, [optionState]); // Trigger when state options are loaded
        
            // Separate useEffect to freeze dropdowns after values are set
            useEffect(() => {
                const userType = sessionStorage.getItem("userTypeCodeModel");
                const stateCode = sessionStorage.getItem("stateNameModel");
                const districtCode = getStoredDistrictRef();
                const subDistrictCode = sessionStorage.getItem("subDistrictNameModel");
                
        
                // Set disabled states based on user type and available values
                if (userType === "2" && stateCode && stateCode !== "null" && stateCode !== "0") {
                    // State admin - freeze state dropdown only
                    setIsStateDisabled(true);
                    setIsDistrictDisabled(false);
                    setIsSubDistrictDisabled(false);
                } else if (userType === "3" && stateCode && stateCode !== "null" && stateCode !== "0") {
                    // District admin - freeze state and district dropdowns
                    setIsStateDisabled(true);
                    setIsDistrictDisabled(true);
                    if (districtCode) {
                        setIsDistrictDisabled(true);
                    }
                } else if (userType === "4" && stateCode && stateCode !== "null" && stateCode !== "0") {
                    // Sub-district admin - freeze state dropdown, others will be frozen after they're selected
                    setIsStateDisabled(true);
                    // For sub-district admin, also set district disabled state if district code is available
                    if (districtCode && districtCode !== "null" && districtCode !== "0") {
                        setIsDistrictDisabled(true);
                    }
                    // District and sub-district will be disabled in their respective useEffects
                } else {
                    // Regular user - enable all
                    setIsStateDisabled(false);
                    setIsDistrictDisabled(false);
                    setIsSubDistrictDisabled(false);
                }
            }, [stateValue]); // Trigger when stateValue changes
        
            // New useEffect to handle district auto-selection after districts are loaded
            useEffect(() => {
                if (optionDistrict.length > 0) {
                    const userType = sessionStorage.getItem("userTypeCodeModel");
                    const districtCode = getStoredDistrictRef();
                    // First select the district value
                    if ((userType === "3" || userType === "4") && districtCode && districtCode !== "null" && districtCode !== "0") {
                        const matchingDistrictOption = findMatchingOption(optionDistrict, districtCode);
                        if (matchingDistrictOption) {
                            setDistrictValue([matchingDistrictOption.value]);
                            setselectedDataSetDistrict(`${matchingDistrictOption.stateid}|${matchingDistrictOption.value}`);
                            
                            // Trigger sub-district loading by calling the API directly
                            const stateCode = stateValue[0] || sessionStorage.getItem("stateNameModel");
                            if (stateCode) {
                                fetchSubDistricts(stateCode, matchingDistrictOption.value);
                            }
                        } else {
                            setDistrictValue([districtCode]);
                        }
                    }
                }
            }, [optionDistrict]); // Trigger when district options are loaded
        
            // Separate useEffect to freeze district dropdown after district value is set
            useEffect(() => {
                const userType = sessionStorage.getItem("userTypeCodeModel");
                const districtCode = getStoredDistrictRef();
                
                // Freeze district dropdown for district and sub-district admins
                if ((userType === "3" || userType === "4") && districtCode && districtCode !== "null" && districtCode !== "0" && districtValue.length > 0) {
                    setIsDistrictDisabled(true);
                }
            }, [districtValue]); // Trigger when districtValue changes
        
            // New useEffect to handle sub-district auto-selection after sub-districts are loaded
            useEffect(() => {
                if (optionSubDistrict.length > 0) {
                    const userType = sessionStorage.getItem("userTypeCodeModel");
                    const subDistrictCode = sessionStorage.getItem("subDistrictNameModel");
                    
                    // First select the sub-district value
                    if (userType === "4" && subDistrictCode && subDistrictCode !== "null" && subDistrictCode !== "0") {
                        // Try to find matching option with different data types
                        const matchingOption = optionSubDistrict.find(option => 
                            option.value == subDistrictCode || 
                            option.value === Number(subDistrictCode) || 
                            option.value === String(subDistrictCode)
                        );
                        
                        if (matchingOption) {
                            setsubDistrictValue([matchingOption.value]);
                            setselectedDataSetSubDistrict(`${matchingOption.districtCode}|${matchingOption.value}`);
                            
                            // Trigger village loading for sub-district admin
                            const stateCode = stateValue[0] || sessionStorage.getItem("stateNameModel");
                            const districtCode = districtValue[0] || getStoredDistrictRef() || matchingOption.districtCode;
                            
                            console.log("Sub-district auto-selection - Village loading attempt:", {
                                stateCode,
                                districtCode,
                                subDistrictCode: matchingOption.value,
                                stateValue,
                                districtValue,
                                matchingOption
                            });
                            
                            if (stateCode && districtCode) {
                                // Add a small delay to ensure all state updates are processed
                                setTimeout(() => {
                                    fetchVillages(stateCode, districtCode, matchingOption.value);
                                }, 100);
                            } else {
                                console.log("Village loading skipped - missing state or district code");
                            }
                        } else {
                            setsubDistrictValue([subDistrictCode]);
                        }
                    }
                }
            }, [optionSubDistrict, stateValue, districtValue]); // Trigger when sub-district options are loaded and state/district values are set
        
            // Separate useEffect to freeze sub-district dropdown after sub-district value is set
            useEffect(() => {
                const userType = sessionStorage.getItem("userTypeCodeModel");
                const subDistrictCode = sessionStorage.getItem("subDistrictNameModel");
                
                // Freeze sub-district dropdown for sub-district admins
                if (userType === "4" && subDistrictCode && subDistrictCode !== "null" && subDistrictCode !== "0" && subdistrictValue.length > 0) {
                    setIsSubDistrictDisabled(true);
                }
            }, [subdistrictValue]); // Trigger when subdistrictValue changes
        
            // Additional useEffect to ensure village loading for sub-district admin when all values are ready
            useEffect(() => {
                const userType = sessionStorage.getItem("userTypeCodeModel");
                const subDistrictCode = sessionStorage.getItem("subDistrictNameModel");
                
                        // If sub-district admin and all required values are available, ensure villages are loaded
                if (userType === "4" && 
                    subDistrictCode && subDistrictCode !== "null" && subDistrictCode !== "0" &&
                    stateValue.length > 0 && 
                    districtValue.length > 0 && 
                    subdistrictValue.length > 0 &&
                    optionVillage.length === 0) { // Only if villages aren't already loaded
                    
                    fetchVillages(stateValue[0], districtValue[0], subdistrictValue[0]);
                }
            }, [stateValue, districtValue, subdistrictValue, optionVillage]); // Trigger when any of these change
        

    // Rupali
    useEffect(() => {
        const savedResults = sessionStorage.getItem("searchResults");
        const savedFilters = sessionStorage.getItem("searchFilters");

        if (savedResults && savedFilters) {
            setfarmerData(JSON.parse(savedResults));
            const filters = JSON.parse(savedFilters);
            setStateValue(filters.stateValue);
            setDistrictValue(filters.districtValue);
            setsubDistrictValue(filters.subDistrictValue);
            setvillageValue(filters.villageValue);
            setselectedDataSetDistrict(filters.selectedDataSetDistrict);
            setselectedDataSetSubDistrict(filters.selectedDataSetSubDistrict);
            setselectedDataSetVillage(filters.selectedDataSetVillage);
        }
    }, []);


    useEffect(() => {

        if (isFetchingState == false) {

            handleState();
            setIsFetchingState(true);
        }

    }, [stateValue]);

    function getStates() {


        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            redirect: "follow",
        };
        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/states`,
            requestOptions

        )
            .then((response) => response.text())
            // .then((result) => setVillageData(JSON.parse(result).dataContent) {
            .then((result) => {
                let localFormDataState = JSON.parse(result).dataContent;
                console.log("localFormData", localFormDataState);
                let myArray = [];
                localFormDataState.map((item, key) => {
                    myArray.push({ label: item.stateName, value: item.stateCode })
                })
                console.log("myArray", myArray)
                setOptionState(myArray)
                setIsFetching(false);
            })
            .catch((error) => console.log("error", error));
    }


    function handleState() {
        setOptionDistrict([]);
        setDistrictValue([]);
        setsubDistrictValue([]);
        setvillageValue([]);

        if (stateValue.length > 1) {
            alert('Please select one value');
            setStateValue([]);
            return false;
        }
        else {
            if (stateValue.length != 0) {

                var myHeaders = new Headers();
                myHeaders.append("Content-Type", "application/json");

                let stateValueData = "";

                stateValue.map((item) => {
                    stateValueData = stateValueData + item + ","
                })

                stateValueData = stateValueData.slice(0, -1);
                var raw = JSON.stringify({
                    stateCode: stateValueData.toString()

                });

                var requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    redirect: "follow",
                    body: raw
                };

                fetch(
                    `${process.env.NODE_ENV === "development"
                        ? process.env.REACT_APP_DEV_MODE
                        : process.env.REACT_APP_PRO_MODE
                    }/api/district`,
                    requestOptions
                )


                    .then((response) => response.text())
                    .then((result) => {
                        let localFormDataDistrict = JSON.parse(result).dataContent;

                        let myArrayDistrict = [];
                        localFormDataDistrict.map((item, key) => {
                            myArrayDistrict.push({ label: item.districtName, value: item.districtCode, stateid: item.stateCode })
                        })

                        setOptionDistrict(myArrayDistrict)
                        setIsFetching(false);
                    })
                    .catch((error) => console.log("error", error));
            }
        }

    }

    let handleChangeDistrict = (districtValue) => {
        setOptionSubDistrict([]);
        setsubDistrictValue([]);
        setvillageValue([]);
        
        setDistrictValue([districtValue.value]);
        setselectedDataSetDistrict(`${districtValue.stateid}|${districtValue.value}`);

        let stateValueData = stateValue.join(',');

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            stateCode: stateValueData,
            districtCode: districtValue.value
        });

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            redirect: "follow",
            body: raw
        };

        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/subdistrict`,
            requestOptions
        )
            .then((response) => response.text())
            .then((result) => {
                let localFormDataSubDistrict = JSON.parse(result).dataContent;

                let myArraySubDistrict = [];
                localFormDataSubDistrict.map((item, key) => {
                    myArraySubDistrict.push({ label: item.subDistrictName, value: item.subDistrictCode, districtCode: item.districtCode })
                })

                setOptionSubDistrict(myArraySubDistrict)
                setIsFetching(false);
            })
            .catch((error) => console.log("error", error));
    };

    let handleChangeSubDistrict = (subdistrictValue) => {
        setvillageValue([]);
        setOptionVillage([]);

        setsubDistrictValue([subdistrictValue.value]);
        setselectedDataSetSubDistrict(`${subdistrictValue.districtCode}|${subdistrictValue.value}`);

            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                stateCode: stateValue.join(','),
                districtCode: districtValue.join(','),
                subDistrictCode: subdistrictValue.value
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
                body: raw
            };

            fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/village`,
                requestOptions
            )
                .then((response) => response.text())
                .then((result) => {
                    let localFormDataVillage = JSON.parse(result).dataContent;

                    let myArrayVillage = [];
                    localFormDataVillage.map((item, key) => {
                        myArrayVillage.push({ label: item.villageName, value: item.villageCode, subDistrictCode: item.subDistrictCode })
                    })

                    setOptionVillage(myArrayVillage)
                    setIsFetching(false);
                })
                .catch((error) => console.log("error", error));
    };

    const fetchDataFilterWise = async () => {
        let result;
        let result1;
       // alert(sessionStorage.getItem("schemeCodeModel"))

        if (sessionStorage.getItem("schemeCodeModel") === "5") {
            setLoaderFarmer(true);

            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsList`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 1,
                "SurveyUserCode": sessionStorage.getItem("schemeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",

            })
            //     const data = await result.data.dataContent;
            //     setfarmerData(data);
            //    // setfarmerData(result.data.dataContent);
            //     setIsFetching(false);

            if (result.data.dataContent.success === true) {

                const data = await result.data.dataContent;
                setfarmerData(data);
                setIsFetching(false);
                setLoaderFarmer(false);
                sessionStorage.setItem("searchResults", JSON.stringify(data));
            sessionStorage.setItem("searchFilters", JSON.stringify({
                stateValue,
                districtValue,
               
                villageValue,
                selectedDataSetDistrict,
                selectedDataSetSubDistrict,
                selectedDataSetVillage
            }));
                // return data;
            }
            else {

                alert('No Data Found.');
                setLoaderFarmer(false);

            }


        } else if (sessionStorage.getItem("schemeCodeModel") === "7") {

            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsList`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 4,
                "SurveyUserCode": sessionStorage.getItem("schemeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
                // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })

            console.log("result", result);

            result1 = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getProjectDetailsList`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 0,
                "SurveyUserCode": sessionStorage.getItem("schemeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
                // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })

            console.log("result1", result1);
            let DataContent = [...result.data.dataContent, ...result1.data.dataContent]
            console.log("dataContent", DataContent)
            setfarmerData(DataContent);
            setIsFetching(false);



        } else if (sessionStorage.getItem("schemeCodeModel") === "3") {
            result1 = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getProjectDetailsList`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 0,
                "SurveyUserCode": sessionStorage.getItem("schemeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
                // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })

            setfarmerData(result1.data.dataContent);
            setIsFetching(false);

        } else if (sessionStorage.getItem("schemeCodeModel") === "6") {
            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsListNew`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
                "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
                // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })
            
            // setfarmerData(result.data.dataContent);
            //  setIsFetching(false);
            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);



        }else if (sessionStorage.getItem("schemeCodeModel") === "9") {
            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsListData`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
                "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
                "PageNumber": page,
                "PageSize": 1000
                // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })
            
            // setfarmerData(result.data.dataContent);
            //  setIsFetching(false);
            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);



        } else if (sessionStorage.getItem("schemeCodeModel") === "8") {
            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MIDH/MIDHFarmerDetails/GetMidhFarmerDetailsAsync`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                // "orgTypeCode": sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
                "orgTypeCode": 0,
                "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
                // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })
            //  setfarmerData(result.data.dataContent);
            //setIsFetching(false);

            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);

        } else if (sessionStorage.getItem("schemeCodeModel") === "10") {
            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/CDB/CDB/GetCDBFarmerDetailsAsync`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                // "orgTypeCode": sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
                "orgTypeCode": 0,
                "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : 0,
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
                //  "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })
            // setfarmerData(result.data.dataContent);
            //  setIsFetching(false);

            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);

        }
        else if (sessionStorage.getItem("schemeCodeModel") === "11") {
            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MIDH/MIDHFarmerDetails/GetDasdFarmerDetailsAsync`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                // "orgTypeCode": sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
                "orgTypeCode": 0,
                "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : 0,
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
                //  "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })
            // setfarmerData(result.data.dataContent);
            // setIsFetching(false);
            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);

        }
        else if (sessionStorage.getItem("schemeCodeModel") === "12") {
            setLoaderFarmer(true);
            if (sessionStorage.getItem("userTypeCodeModel") === "5") {
                result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsOnly`, {
                   
                    "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "UperLevelUserCode": "0",
                    "PageNumber": page


                })
            }
            else {


                result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsOnly`, {

                    "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "PageNumber": page


                })
            }
            //  setfarmerData(result.data.dataContent);
            //  setIsFetching(false);

            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);

        }
        else if (sessionStorage.getItem("schemeCodeModel") === "13") {
            setLoaderFarmer(true);
            if (sessionStorage.getItem("userTypeCodeModel") === "5") {
                result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/CropInsurance/GetSurveyDetails`, {

                    "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "UperLevelUserCode": "0",
                    "SchemeCode": "13"


                })
            }
            else {


                result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/CropInsurance/GetSurveyDetails`, {

                    "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "SchemeCode": "13"


                })
            }
            //   setfarmerData(result.data.dataContent);
            //  setIsFetching(false);
            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);

        }
        else if (sessionStorage.getItem("schemeCodeModel") === "1") {
            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsOnly`, {

                "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 1,
                "SurveyUserCode": "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? "0" : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? "0" : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": "0",
                "PageNumber": page
            })
            //setfarmerData(result.data.dataContent);
            // setIsFetching(false);

            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);

        }
        else {
            let stateValueData = "0";
        let districtValueData = "0";
        let subdistrictValueData = "0";
        let villageValueData = "0";

        stateValueData = stateValue.join(',');

        if (selectedDataSetDistrict != "") {
            const districtParts = selectedDataSetDistrict.split("|");
            districtValueData = districtParts[1];
        }
        if (selectedDataSetSubDistrict != "") {
            const SubdistrictParts = selectedDataSetSubDistrict.split("|");
            subdistrictValueData = SubdistrictParts[1];
        }
        if (selectedDataSetVillage != "") {
            const VillageDataParts = selectedDataSetVillage.split("|");
            villageValueData = VillageDataParts[1];
        }

            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsList`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
                "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
               "stateCode": stateValueData,
               "districtCode": districtValueData,
                "subDistrictCode": subdistrictValueData,
                "villageCode": villageValueData,
                "PageNumber": page
                // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })
            // setfarmerData(result.data.dataContent);
            //  setIsFetching(false);


             const data = await result.data.dataContent;
           
            console.log('data---------------',data);
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);
            sessionStorage.setItem("searchResults", JSON.stringify(data));
            sessionStorage.setItem("searchFilters", JSON.stringify({
                stateValue,
                districtValue,
               
                villageValue,
                selectedDataSetDistrict,
                selectedDataSetSubDistrict,
                selectedDataSetVillage
            }));
            if (result.data.success != true) {
                  alert('No Data Found.');
                  setLoaderFarmer(false);
            }


        }



        // const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/users`);

    };

 let handleChange = (selectedOption) => {
        // Check user type - if state admin (type 2) or district admin (type 3), don't allow changes
        const userType = sessionStorage.getItem("userTypeCodeModel");
        if (userType === "2" || userType === "3") {
            console.log("State change blocked - User is admin type:", userType);
            return;
        }
        
        console.log("State changed to:", selectedOption);
        setIsFetchingState(false);
        setStateValue(selectedOption ? [selectedOption.value] : []);
        
        // Clear dependent fields
        if (!selectedOption) {
            setDistrictValue('');
            setOptionDistrict([]);
            setsubDistrictValue('');
            setOptionSubDistrict([]);
            setvillageValue('');
            setOptionVillage([]);
            setselectedDataSetDistrict('');
            setselectedDataSetSubDistrict('');
            setselectedDataSetVillage('');
            // Clear farmer data when state is cleared
            setfarmerData([]);
            setErrorMessage('');
        }
    };

    let handleChangeVillage = (villageValue) => {
        setvillageValue([villageValue.value]);
        setselectedDataSetVillage(`${villageValue.subDistrictCode}|${villageValue.value}`);
    };

    function formatData(value) {
        if (sessionStorage.getItem("schemeCodeModel") === "8" || sessionStorage.getItem("schemeCodeModel") === "10" || sessionStorage.getItem("schemeCodeModel") === "11") {
            return value.componentName
        }
        console.log("value name", value.orgTypeCode);
        if (value.orgTypeCode === 1) {
            return "Honey Processing Unit"
        } else if (value.orgTypeCode === 2) {
            return "Honey Testing Unit"
        } else if (value.orgTypeCode === 3) {
            return "Honey CHC"
        } else if (value.orgTypeCode === 4) {
            return "Beeflora Plantation"
        }
    }

    function formatData2(value) {
        console.log("value name", value.orgTypeCode);
        if (value.orgTypeCode === 1) {
            return "Nursery"
        } else if (value.orgTypeCode === 2) {
            return "Tissue Culture Unit"
        } else {
            return "Tissue Culture Unit"
        }
    }

    const fetchDataExporttoCsv = async () => {
       
      setLoaderFarmer(true);
      
      let stateValueData = "";
      let districtValueData = "0";
      let subdistrictValueData = "0";
      let villageValueData = "0";

      // Concatenate all state values with a comma
      stateValue.forEach((item) => {
        stateValueData += item + ",";
      });
      // Remove trailing comma
      stateValueData = stateValueData.slice(0, -1);

      // If stateValueData is null or empty, set stateCode to "0"
      const stateCode = stateValueData === "" || stateValueData === null ? "0" : stateValueData;

      if (selectedDataSetDistrict !== "") {
        const districtParts = selectedDataSetDistrict.split("|");
        districtValueData = districtParts[1];
      }
      if (selectedDataSetSubDistrict !== "") {
        const SubdistrictParts = selectedDataSetSubDistrict.split("|");
        subdistrictValueData = SubdistrictParts[1];
      }
      if (selectedDataSetVillage !== "") {
        const VillageDataParts = selectedDataSetVillage.split("|");
        villageValueData = VillageDataParts[1];
      }
      console.log("stateValueData", stateCode);
      console.log("districtValueData", districtValueData);
      console.log("subdistrictValueData", subdistrictValueData);
      console.log("villageValueData", villageValueData);

      let result;
      if (sessionStorage.getItem("schemeCodeModel") === "12") {
        result = await axios.post(
          `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsExport`,
          {
           
            stateCode: stateCode, // Use our conditional stateCode here
            districtCode: districtValueData,
            subDistrictCode: subdistrictValueData,
            villageCode: villageValueData,
            PageNumber: 1,
          }
        );
        if (result.data.success === true) {
          const data = await result.data.dataContent;
          setIsFetching(false);
          setLoaderFarmer(false);
          return data;
        } else {
          alert("something went wrong.");
          setLoaderFarmer(false);
        }
      }
    };


    const handleExportDataNew = async () => {
        
        let allowed;
        const farmerDataExportNew = await fetchDataExporttoCsv();
        allowed = ['surveyCode', 'schemeName', 'stateName', 'districtName', 'subDistrictName', 'villageName', 'currentyear', 'minorCropCategoryName', 'showingDate', 'polygonArea', 'cropCategoryName', 'cropName', 'cropConditionName', 'cropStageName', 'cropingTypeName', 'polygonShape', 'surveyorName', 'createdOnByUC', 'ratioofmajorcrop', 'minorCropName', 'surveyorLat', 'surveyorLong', 'userMobile', 'imgPath', 'company_name', 'minorCropCategoryName']
        //console.log("Test Data", farmerDataExportNew[0]);
        var result = farmerDataExportNew.map(function (obj) {
            var newObj = {};

            allowed.forEach(function (key) {

                newObj[key] = obj[key];


            });
            return newObj;
        });
        const csvOptions = {
            fieldSeparator: ",",
            quoteStrings: '"',
            decimalSeparator: ".",
            showLabels: true,
            useBom: true,
            useKeysAsHeaders: false,
            headers: allowed,
        };

        const csvExporter = new ExportToCsv(csvOptions);
        csvExporter.generateCsv(result);

    }
    const handleExportDataNewu = async () => {
       
    try {
        // Fetch data
        const farmerDataExportNew = await fetchDataExporttoCsv();
       //  console.log("aaaaaaaaaaaaaaaaaaaaaaa",farmerDataExportNew.data.dataContent)
        if(farmerDataExportNew.data.dataContent.length !=0){
        // Check if data is valid
        if (!farmerDataExportNew || !Array.isArray(farmerDataExportNew)) {
            console.error("Error: fetchDataExporttoCsv() returned invalid data", farmerDataExportNew);
            alert("Failed to export: No data available.");
            return;
        }

        // Allowed keys for export
       // const  allowed = ['surveyCode', 'schemeName', 'stateName', 'districtName', 'subDistrictName', 'villageName', 'currentyear', 'minorCropCategoryName', 'showingDate', 'polygonArea', 'cropCategoryName', 'cropName', 'cropConditionName', 'cropStageName', 'cropingTypeName', 'polygonShape', 'surveyorName', 'createdOnByUC', 'ratioofmajorcrop', 'minorCropName', 'surveyorLat', 'surveyorLong', 'userMobile', 'imgPath', 'company_name', 'minorCropCategoryName']
        const  allowed = ['surveyCode', 'schemeName', 'stateName', 'districtName']
       

        // Transform data
        const result = farmerDataExportNew.map(obj => {
            let newObj = {};
            allowed.forEach(key => {
                newObj[key] = obj[key] ?? ""; // Ensure empty string for missing values
            });
            return newObj;
        });

        console.log("Export Data:", result);
        // Add export logic here
        const csvOptions = {
            fieldSeparator: ",",
            quoteStrings: '"',
            decimalSeparator: ".",
            showLabels: true,
            useBom: true,
            useKeysAsHeaders: false,
            headers: allowed,
        };

        const csvExporter = new ExportToCsv(csvOptions);
        csvExporter.generateCsv(result);
       } 
    } catch (error) {
        console.error("Error in handleExportDataNew:", error);
        alert("An error occurred while exporting data.");
    }
    };


    const handleExportData = () => {
        
    let allowed = [
        'schemeName',
        'stateName',
        'districtName',
        'subDistrictName',
        'villageName',
        'gisSchemeName',
        'farmerName',
        'mobileNo',
        'surveyNo',
        'SurveyorName',
        'DesigName',
        'finYear',
        'caste',
        'gender',
        'createdDate',
        'farmerType',
        'componentName',
        'seasonName'
    ];

    const result = farmerData?.map(obj => {
        const cropDetails = Array.isArray(obj.farmerCropDetailsExtsList) ? obj.farmerCropDetailsExtsList[0] : {};

        return {
            schemeName: obj.schemeName,
            stateName: obj.stateName,
            districtName: obj.districtName,
            subDistrictName: obj.subDistrictName,
            villageName: obj.villageName,
            gisSchemeName: obj.gisSchemeName,
            farmerName: obj.farmerName,
            mobileNo: obj.mobileNo,
            surveyNo: obj.surveyNo,
            SurveyorName: obj.surveyorName,
            DesigName: obj.desigName,

            // New fields
            finYear: cropDetails?.finYear || '',
            caste: obj.casteCatName || '',
            gender: obj.gender || '',
            createdDate: obj.createdOn ? new Date(obj.createdOn).toLocaleDateString() : '',
            farmerType: obj.farmerType === 1 ? "Small and Marginal" : "Other",
            componentName: cropDetails?.cropGroupName || '',
            seasonName: cropDetails?.seasonName || ''
        };
    });

    const csvOptions = {
        fieldSeparator: ",",
        quoteStrings: '"',
        decimalSeparator: ".",
        showLabels: true,
        useBom: true,
        useKeysAsHeaders: false,
        headers: allowed,
    };

    const csvExporter = new ExportToCsv(csvOptions);
    csvExporter.generateCsv(result);
    };



    function ValidateUpdateUser() {

        let valid = false;

        if (mobilenoValue === "") {
            alert("Enter Mobile no")

            valid = false;
            return;
        } else {
            valid = true;

        }
        if (landareaValue === "") {
            alert("Enter land area")

            valid = false;
            return;
        } else {
            valid = true;

        }

        if (totalareaValue === "") {
            alert("Enter total area")

            valid = false;
            return;
        } else {
            valid = true;

        }

        if (surveynoValue === "") {
            alert("Enter Survey No")

            valid = false;
            return;
        } else {
            valid = true;

        }


        if (valid === true) {
            UpdateNewUser()
        }



    }

    function UpdateNewUser() {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({

            "createdByUC": sessionStorage.getItem("userCodeModel"),
            "schemeCode": sessionStorage.getItem("schemeCodeModel"),
            "farmerCode": editCode,
            "mobileNo": mobilenoValue,
            "surveyNo": surveynoValue,
            "landArea": landareaValue,
            "totalArea": totalareaValue
        });

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/Nature/FarmerDetails/UpdateFarmerDetails`,
            requestOptions
        )
            .then((response) => response.text())
            .then((result) => {
               // alert(JSON.parse(result).message);
                if (JSON.parse(result).success == true) {
                    //   setFlag(true);
                    // navigate("/newadminpanel/userlist");
                }
            })
            .catch((error) => console.log("error", error));

    }

    const handlePrevPage = async () => {
        setLoaderFarmer(true);
        let result;
        setPage(page - 1);
        if (sessionStorage.getItem("schemeCodeModel") === "1") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsOnly`, {

                "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 1,
                "SurveyUserCode": "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? "0" : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? "0" : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": "0",
                "PageNumber": page - 1
            })
        }
       else if (sessionStorage.getItem("schemeCodeModel") === "9") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsListData`, {

                "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 1,
                "SurveyUserCode": "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? "0" : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? "0" : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": "0",
                "PageNumber": page - 1,
                "PageSize": 1000
            })
        }
        else if (sessionStorage.getItem("schemeCodeModel") === "12") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsOnly`, {

                "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                "PageNumber": page - 1
            })
        }
        const data = await result.data.dataContent;
        setLoaderFarmer(false);
        setfarmerData(data);
        setIsFetching(false);
        setHasNextPage(true)
    };

    const handleNextPage = async () => {
        setLoaderFarmer(true);

        setPage(page + 1);
        let result;
        if (sessionStorage.getItem("schemeCodeModel") === "1") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsOnly`, {

                "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 1,
                "SurveyUserCode": "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? "0" : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? "0" : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": "0",
                "PageNumber": page + 1
            })
        }
        else if (sessionStorage.getItem("schemeCodeModel") === "9") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsListData`, {

                "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 1,
                "SurveyUserCode": "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? "0" : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? "0" : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": "0",
                "PageNumber": page + 1,
                "PageSize": 1000
            })
        }
        else if (sessionStorage.getItem("schemeCodeModel") === "12") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsOnly`, {

                "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                "PageNumber": page + 1
            })
        }
        const data = await result.data.dataContent;
        setLoaderFarmer(false);
        setfarmerData(data);
        if (result.data.message === "Data Not Found") {
            setHasNextPage(false)
        }
        setIsFetching(false);
    };


    function handleSurveyNumber(value) {
        const valueFinal = value.replace(/\D/g, "");
        setSurveyValue(valueFinal)
    }

    function handleSurveyorName(value) {
        //alert(value);
       // const valueFinal = value.replace(/\D/g, "");
        setSurveyorNameValue(value)
        console.log("value==========",value)
        
    }



    const fetchDataFilterWises = async () => {
        setLoaderFarmer(true);
        setfarmerData([]);
        let stateValueData = "0";
        let districtValueData = "0";
        let subdistrictValueData = "0";
        let villageValueData = "0";
        
        stateValueData = stateValue.join(',');

        if (selectedDataSetDistrict != "") {
            const districtParts = selectedDataSetDistrict.split("|");
            districtValueData = districtParts[1];
        }
        if (selectedDataSetSubDistrict != "") {
            const SubdistrictParts = selectedDataSetSubDistrict.split("|");
            subdistrictValueData = SubdistrictParts[1];
        }
        if (selectedDataSetVillage != "") {
            const VillageDataParts = selectedDataSetVillage.split("|");
            villageValueData = VillageDataParts[1];
        }
      

        let result;
        if (sessionStorage.getItem("schemeCodeModel") === "12") {

            if (surveyValue != '') {
                result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetails`, {
                    "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "CropSurveyCode": surveyValue
                });
            }
            else {
                result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsOnly`, {
                    "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "schemeCode": "12",
                    "stateCode": stateValueData,
                    "districtCode": districtValueData,
                    "subDistrictCode": subdistrictValueData,
                    "villageCode": villageValueData,
                    "surveyorName": surveyorNameValue,
                    "cropSeasonValue": cropSeasonValue,
                    "cropGroupValue": cropGroupValue,
                    "cropNameValue": cropNameValue,
                    "fromdate": startDate,
                    "todate": endDate,
                    "PageNumber": 1
                });
            }


            if (result.data.success === true) {

                const data = await result.data.dataContent;
                setfarmerData(data);
                setIsFetching(false);
                setLoaderFarmer(false);
                sessionStorage.setItem("searchResults", JSON.stringify(data));
            sessionStorage.setItem("searchFilters", JSON.stringify({
                stateValue,
                districtValue,
               
                villageValue,
                selectedDataSetDistrict,
                selectedDataSetSubDistrict,
                selectedDataSetVillage
            }));
                // return data;
            }
            else {

                alert('No Data Found.');
                setLoaderFarmer(false);

            }
        }

        if (sessionStorage.getItem("schemeCodeModel") === "14") {

          
                result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/NMEO_OP/getNMEOFarmerDetailsList`, {
                   
                    "schemeCode": "14",
                    "orgTypeCode": "1",
                    "lngA_FarmerCode": "0",
                    "int_Block_Code": "0",
                    "lng_SurveyUserCode": "0",
                    "str_MobileNo": "",
                    "int_State_Code": stateValueData,
                    "int_District_Code": districtValueData,
                    "int_SubDistrict_Code": subdistrictValueData,
                    "int_VillageCode": villageValueData,
         });
            


            if (result.data.success === true) {

                const data = await result.data.dataContent;
                setfarmerData(data);
                setIsFetching(false);
                setLoaderFarmer(false);
                sessionStorage.setItem("searchResults", JSON.stringify(data));
            sessionStorage.setItem("searchFilters", JSON.stringify({
                stateValue,
                districtValue,
               
                villageValue,
                selectedDataSetDistrict,
                selectedDataSetSubDistrict,
                selectedDataSetVillage
            }));
                // return data;
            }
            else {

                alert('No Data Found.');
                setLoaderFarmer(false);

            }
        }

        if (sessionStorage.getItem("schemeCodeModel") === "9") {

            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsListData`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
                "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
                "PageNumber": page,
                "PageSize": 1000
                // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })
            
            // setfarmerData(result.data.dataContent);
            //  setIsFetching(false);
            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);
           } 

        if (sessionStorage.getItem("schemeCodeModel") === "15") {

            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/RKVY/RKVYProject/RKVYProjectExtList`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
                "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": districtValueData,
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
                "PageNumber": page,
                "PageSize": 1000
                // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })
            
            // setfarmerData(result.data.dataContent);
            //  setIsFetching(false);
            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);
           }         

    };

    function ClearSearch(){
         // Only clear fields that are not disabled for this user type
        if (!isStateDisabled) {
            setStateValue([]);
            setOptionDistrict([]);
        }
        if (!isDistrictDisabled) {
            setDistrictValue([]);
            setselectedDataSetDistrict('');
            setOptionSubDistrict([]);
        }
        if (!isSubDistrictDisabled) {
            setsubDistrictValue([]);
            setselectedDataSetSubDistrict('');
        }
        setStateValue([]);
        setOptionDistrict([]);
        setDistrictValue([]);
        setfarmerData([]);
        setselectedDataSetDistrict('');
        setOptionSubDistrict([]);
        setsubDistrictValue([]);
        setOptionVillage([]);
        setvillageValue([]);
        setselectedDataSetSubDistrict('');
        setselectedDataSetVillage('');
        setSurveyValue('');
        setSurveyorNameValue('');
        setStartDate("");
        setEndDate("");
        sessionStorage.removeItem("searchResults");
        sessionStorage.removeItem("searchFilters");
    }

    function ValidateAddUser() {
    //alert(sessionStorage.getItem("schemeCodeModel"))
   // alert()
   
    if (stateValue.length === 0) {
       
         setErrorMessage("Please select at least one State.");
            return false;
    }
    if (stateValue.length > 1) {
       setErrorMessage("Please select only one State.");
            return false;
    }
    /*if (districtValue.length === 0) {
        setErrorMessage('Please select at least one District');
        return false;
    }*/
    if (districtValue.length > 1) {
        setErrorMessage('Please select only one District');
        return false;
    }
    
    if (sessionStorage.getItem("schemeCodeModel") === "12") {
    if (!startDate) {
         setErrorMessage('Start Date is required.');
       
        return false;
    }

     if (!endDate) {
        setErrorMessage('End Date is required.');
        return false;
    } else if (startDate && endDate < startDate) {
        setErrorMessage('End Date cannot be earlier than Start Date.');
        return false;
        
    }

    }
    // If all validations pass, fetch the filtered data
    setErrorMessage("") 
    fetchDataFilterWise();

    }


    function navigateData(userData) {
        navigate("/newadminpanel/farmer/detailview", { state: { farmerCode: userData } })
    }



    const columns = useMemo(() => {
    const schemeCodeModel = sessionStorage.getItem("schemeCodeModel");

    return [
        {
            header: 'S.No',
            Cell: cell => Number(cell.row.id) + 1,
            size: 20,
        },
         // Conditional View/Action Button column
        (schemeCodeModel === "12" || schemeCodeModel === "13") ? {
            size: 100,
            header: 'View Details',
            Cell: cell => (
                <button className="btn" type="button" onClick={() => navigate("/newadminpanel/survey/detailview", { state: { farmerCode: cell.row.original } })}>
                    <i><FontAwesomeIcon icon={faEye} /></i>
                </button>
            )
        } : (schemeCodeModel === "9") ? {
            size: 100,
            header: 'Action',
            Cell: cell => (<>
                <i className="btn" type="button" onClick={() => navigateData(cell.row.original)}>
                    <FontAwesomeIcon icon={faEye} />
                </i>
                <i className="btn text-danger" type="button" data-bs-toggle="modal" data-bs-target="#staticBackdrop_user" onClick={() => setEditCode(cell.row.original.farmerCode)}>
                    <FontAwesomeIcon icon={faEdit} />
                </i>
            </>)
        } : {
            header: 'View Details',
            size: 80,
            Cell: cell => (
                <button className="btn" type="button" onClick={() => navigate("/newadminpanel/farmer/detailview", { state: { farmerCode: cell.row.original } })}>
                    <i><FontAwesomeIcon icon={faEye} /></i>
                </button>
            )
        },
        {
            accessorKey: 'stateName',
            header: 'State',
            size: 100,
        },
        {
            accessorKey: 'districtName',
            header: 'District',
            size: 100,
        },
        {
            accessorKey: 'subDistrictName',
            header: 'Sub District',
            size: 100,
        },
       
        {
            accessorKey: 'villageName',
            header: 'Village',
            size: 100,
        },
        {
            accessorKey: 'mobileNo',
            header: 'Mobile No',
            size: 100,
        },
        {
            accessorKey: 'casteCatName',
            header: 'Caste',
            size: 100,
        },
        {
            accessorKey: 'gender',
            header: 'Gender',
            size: 100,
        },
        {
            accessorKey: 'createdOn',
            header: 'Created Date',
            Cell: cell => new Date(cell.row.original.createdOn).toLocaleDateString(),
            size: 100,
        },
        {
            accessorKey: 'surveyNo',
            header: 'Survey No',
            size: 100,
        },
        {
            header: 'Financial Year',
            Cell: cell => cell.row.original.farmerCropDetailsExtsList?.[0]?.finYear || '',
             size: 100,   
        },

        // Conditional columns for schemeCodeModel === "15"
        ...(schemeCodeModel === "15" ? [
            { accessorKey: 'userName', header: 'User Name' },
            { accessorKey: 'sectorName', header: 'Sector Name' },
            { accessorKey: 'projectStatus', header: 'Project Status' }
        ] : []),

      
    ].filter(Boolean); // Remove any null/undefined entries
}, []);



    return (
        <>
          
           <section className="section">

                <div className="row surveydetailsBg">
                    <div className="col-md-3">
                        <label htmlFor="State" className="form-label">
                            State
                        </label><label style={{ color: "red" }}>*</label>
                     <Select
                options={optionState}
               
                value={
                  stateValue && stateValue[0]
                    ? findMatchingOption(optionState, stateValue[0])
                    : null
                }
                onChange={handleChange}
                isClearable={!isStateDisabled}
                isSearchable={true}
                isDisabled={isStateDisabled}
                placeholder="Select State"
                classNamePrefix="select"
              />
                    </div>

                    <div className="col-md-3">
                        <label htmlFor="District" className="form-label">
                            District
                        </label><label style={{ color: "red" }}></label>
                        <Select
                            options={optionDistrict}
                            value={optionDistrict.filter(option => districtValue.includes(option.value))}
                            onChange={isDistrictDisabled ? () => {} : handleChangeDistrict}
                            labelledBy={"Select"}
                            isCreatable={false}
                            disabled={isDistrictDisabled}
                            defaultValue={districtValue} />
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="SubDistrict" className="form-label">
                            Sub District
                        </label><label style={{ color: "red" }}></label>
                        <Select
                            options={optionSubDistrict}
                            value={optionSubDistrict.filter(option => subdistrictValue.includes(option.value))}
                            onChange={handleChangeSubDistrict}
                            labelledBy={"Select"}
                            isMulti={false}
                            isClearable={true}
                            placeholder="Select Sub District" />
                    </div>

                    <div className="col-md-3">
                        <label htmlFor="Village" className="form-label">
                            Village
                        </label><label style={{ color: "red" }}></label>
                        <Select
                            options={optionVillage}
                            value={optionVillage.filter(option => villageValue.includes(option.value))}
                            onChange={handleChangeVillage}
                            labelledBy={"Select"}
                            isMulti={false}
                            isClearable={true}
                            placeholder="Select Village" />
                    </div>
                    
                  <br /> <br />                     
                  <div className="col-md-12 d-flex justify-content-md-center mt-3">

                    <button type="button" className="btn btn-primary farmrbtn me-md-2" onClick={ValidateAddUser} >Submit</button>
                    <button type="button" className="btn btn-success me-md-2"  onClick={ClearSearch}>Clear</button>
                </div>

                </div>
                
                {errorMessage && (
                        <div class="alert alert-danger" role="alert">
                         {errorMessage}
                        </div>
                    )} 

       
            {LoaderFarmer === false ? "" : <div class="overlay">
                <div class="overlay__inner">
                    <div class="overlay__content"><span class="spinner"></span></div>
                </div>
            </div>}


                    {(farmerData.length!=0  &&
                    <div className="row justify-content-lg-center">

                        <div className="col-lg-12 ">

                            <div className="card">

                                <MaterialReactTable
                                    columns={columns}
                                    data={farmerData}
                                    enableColumnOrdering
                                    enablePagination={true}
                                    state={{ isLoading: isFetching ? true : false }}
                                    renderTopToolbarCustomActions={({ table }) => (
                                        <Box
                                            sx={{
                                                display: "flex",
                                                gap: "1rem",
                                                p: "0.5rem",
                                                flexWrap: "wrap",
                                            }}
                                        >
                                            {sessionStorage.getItem("schemeCodeModel") === "12" ?
                                                <Button
                                                    color="primary"
                                                    //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                                                    onClick={handleExportDataNew}
                                                    startIcon={<FileDownloadIcon />}
                                                    variant="contained"
                                                >
                                                    Export in CSV
                                                </Button>

                                                :
                                                <Button
                                                    color="primary"
                                                    //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                                                    onClick={handleExportData}
                                                    startIcon={<FileDownloadIcon />}
                                                    variant="contained"
                                                >
                                                    Export in CSV
                                                </Button>
                                            }

                                        </Box>
                                    )}
                                />
                                

                            </div>

                        </div>


                    </div>
                )}
           </section>

        

         
          
        </>
    )
}

export default RADList;